import { render } from "./PortDetails.vue?vue&type=template&id=56749100"
import script from "./PortDetails.vue?vue&type=script&lang=js"
export * from "./PortDetails.vue?vue&type=script&lang=js"

import "./PortDetails.vue?vue&type=style&index=0&id=56749100&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__